import { Router, NavigationEnd } from '@angular/router';
import { GraficasService } from '../servicios/graficas.service';
import { Constants } from '../constants/constants';
import { ColorsService } from '../servicios/colors.service';
import { Component, OnInit } from '@angular/core';
import * as chart from 'chart.js';
import swal from'sweetalert2';
import { Utils } from '../utils/utils';
import { AgenciaService } from '../servicios/agencia.service';
import { FormGroup, FormBuilder } from '@angular/forms';




@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {


  url: string = "";

  datapieCategoria = {};
  dataServiceCategorias: any;
  labelsCategorias = [];
  dataCategorias = [];
  backgroundColorCategoria = [];
  hoverBackgroundColorCategoria = [];
  optionsPie: any;

  dataBarEmpresa = {};
  dataServiceEmpresas: any;
  labelsEmpresas = [];
  dataEmpresas = [];
  backgroundColorEmpresa = [];

  datapieMedio = {};
  dataServiceMedios: any;
  labelsMedios = [];
  dataMedios = [];
  backgroundColorMedio = [];


  /*dataBarPrioridad = {};
  dataServicePrioridades: any;
  labelsPrioridades = [];
  dataPrioridades = [];
  backgroundColorPrioridad = [];*/

  colorSpinner = "primary";

  dataBarAsesor = {};
  dataServiceAsesores: any;
  labelsAsesores = [];
  dataAsesores = [];
  backgroundColorAsesor = [];


  entregasStacked: any;
  agenciasStacked: any;
  PieMedio: any;
  BarPrioridad: any;
  BarAsesor: any;


  mostrarEntregadoresStacked = false;
  mostrarAgenciasStacked = false;
  mostrarMedios = false;
  mostrarAsesor = false;
  contenidoAlerta:string ='';

  agencias: any[] = [];

  agenciaGroup:FormGroup;


  constructor(
    private colorService: ColorsService,
    private graficaService: GraficasService,
    private servicioAgencia:AgenciaService,
    private formBuilder:FormBuilder,
    private router: Router,
    private ruta: Utils
  ) {
    this.url = Constants.BASE_URL;

    this.agenciaGroup = this.formBuilder.group({
      IdAgencia: ['']
    });

    const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    this.servicioAgencia.getAgencia(infoUsuario[0].IdUsuario, 0)//se envia cero para devolver todas las agencias y el id de agencia para devovler una especifica
    .subscribe(result=>{
      this.agencias=result;
      this.agenciaGroup.controls['IdAgencia'].setValue(this.agencias[0].id);
      this.generarGraficas(this.agencias[0].id);
    });
//alert("llega");
    // override the route reuse strategy
    /*this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });*/
  }


  generarGraficas(agencias){
    //console.log(agencias);
    //this.entregasStacked.destroy();
    this.mostrarEntregadoresStacked = false;
    this.mostrarAgenciasStacked = false;
    /*if(!this.entregasStacked === undefined){
      this.entregasStacked.destroy();
    }
    if(!this.agenciasStacked === undefined){
      this.agenciasStacked.destroy();
    }*/
    agencias = '|'+agencias+'|';
    this.getGraficas('entregadores', agencias);
    this.getGraficas('agencias', agencias);
  }

  getGraficas(grafica, agencia): void {

    //###################CATEGORIA######################//
    if (grafica == 'entregadores') {
      this.graficaService.getGraficaEntregadoresStacked(agencia, 1)
        .subscribe((data) => {  
          
          const dataServer = data;
          const labels=[];
          const dataSets=[];          
          const dataAsignados=[];
          const dataEntregados=[];
          const dataPendientes=[];
          let bgAsignados=[];
          let bgEntregados=[];
          let bgPendientes=[];
          dataServer.forEach(element => {
            labels.push(element.Nombre.substring(0, 10));
            dataAsignados.push(element.gestionados);           
            dataEntregados.push(element.entregados);                        
            dataPendientes.push(element.pendientes);
            bgAsignados.push('#45add6');
            bgEntregados.push('#37cc0e');
            bgPendientes.push('#cc0e27');
          });
          const configBarStackedData={
            type:'bar',
            data:{
              labels:labels,
              datasets:[
                {
                  label:'Asignados',
                  data:dataAsignados,
                  backgroundColor:bgAsignados
                },
                {
                  label:'Gestionados',
                  data:dataEntregados,
                  backgroundColor:bgEntregados
                },
                {
                  label:'Pendientes',
                  data:dataPendientes,
                  backgroundColor:bgPendientes
                }
              ]
            },
            options: {
              scales: {
                yAxes: [{
                  stacked: true,
                  ticks: {
                    beginAtZero: true
                  }
                }],
                xAxes: [{
                  stacked: true,
                  ticks: {
                    beginAtZero: true,
                    fontSize: 10,
                    autoSkip: false,
                    maxRotation: 90,
                    minRotation: 90
                  }
                }]
          
              }
            }
          };
          this.mostrarEntregadoresStacked=true;
          //console.log(JSON.stringify(configBarStackedData));

          if (this.entregasStacked) this.entregasStacked.destroy();

          let canvas: any = document.getElementById("entregasStacked");

          this.entregasStacked = new chart(canvas, configBarStackedData);
          
        });
    }
    //###################END CATEGORIA######################//

    //###################EMPRESAS###########################//
    else if (grafica == 'agencias') {
      this.graficaService.getGraficaEntregadoresStacked(agencia, 2)
        .subscribe((data) => {
          
          const dataServer = data;
          const labels=[];
          const dataSets=[];          
          const dataAsignados=[];
          const dataCerrados=[];
          const dataEnviadosOk=[];
          const dataEnviadosError=[];
          dataServer.forEach(element => {
            labels.push(element.descripcion);
            dataAsignados.push(element.gestionados);
            dataCerrados.push(element.gestionados);
            dataEnviadosOk.push(element.enviadosOk);
            dataEnviadosError.push(element.enviadosError);
          });
          const configBarStackedData={
            type:'bar',
            data:{
              labels:labels,
              datasets:[
                {
                  label:'Asignados',
                  data:dataAsignados,
                  backgroundColor:['#ebdb2d','#ebdb2d','#ebdb2d','#ebdb2d']
                },
                {
                  label:'Gestionados',
                  data:dataCerrados,
                  backgroundColor:['#37cc0e', '#37cc0e', '#37cc0e', '#37cc0e']
                },
                {
                  label:'Enviados OK',
                  data:dataEnviadosOk,                  
                  backgroundColor:['#45add6','#45add6','#45add6','#45add6']
                },
                {
                  label:'Enviados Error',
                  data:dataEnviadosError,
                  backgroundColor:['#cc0e27','#cc0e27','#cc0e27','#cc0e27']
                }
              ]
            },
            options: {
              scales: {
                yAxes: [{
                  stacked: true,
                  ticks: {
                    beginAtZero: true
                  }
                }],
                xAxes: [{
                  stacked: true,
                  ticks: {
                    beginAtZero: true
                  }
                }]
          
              }
            }
          };
          this.mostrarAgenciasStacked=true;
          //console.log(JSON.stringify(configBarStackedData));

          if (this.agenciasStacked) this.agenciasStacked.destroy();

          let canvas: any = document.getElementById("agenciasStacked");

          this.agenciasStacked = new chart(canvas, configBarStackedData);

        });
    }
    //#####################END EMPRESA##########################//
    //###################MEDIOS######################//
    else if (grafica == 'medios') {
      this.graficaService.getGrafica(grafica)
        .subscribe((data) => {
          //alert(JSON.stringify(this.labelsCategorias));
          this.dataServiceMedios = data;
          this.mostrarMedios = true;
          this.dataServiceMedios.forEach((value: any, key: any) => {
            this.labelsMedios.push(value.MEDIO);
            this.dataMedios.push(value.cantidad);
            let color = this.colorService.getRandomColor(key);
            this.backgroundColorMedio.push(color);
          });


          let configPieMedio = {
            type: 'pie',
            data: {
              datasets: [{
                data: this.dataMedios,
                backgroundColor: this.backgroundColorMedio,
                label: 'Dataset 1'
              }],
              labels: this.labelsMedios
            },
            options: {
              legend: {
                display: false
              },
              responsive: true
            }
          };

          let canvasPieMedio: any = document.getElementById("pieMedios");

          this.PieMedio = new chart(canvasPieMedio, configPieMedio);

        });
    }
    //###################END MEDIOS######################//

    //###################PRIORIDADES###########################//
    /*else if (grafica == 'prioridades') {
      this.graficaService.getGrafica(grafica)
        .subscribe((data) => {
          //alert(JSON.stringify(this.labelsCategorias));
          this.dataServicePrioridades = data;
          this.dataServicePrioridades.forEach((value: any, key: any) => {
            this.labelsPrioridades.push(value.PRIORIDAD);
            this.dataPrioridades.push(value.cantidad);
            let color = this.colorService.getRandomColor(key);
            this.backgroundColorPrioridad.push(color);
            //this.hoverBackgroundColorCategoria.push(color);


            //alert(JSON.stringify(value));
          });

          let configBarPrioridades = {
            type: 'bar',
            data: {
              datasets: [{
                label: 'Solicitudes',
                backgroundColor: this.backgroundColorPrioridad,
                borderColor: this.backgroundColorPrioridad,
                borderWidth: 1,
                data: this.dataPrioridades
              }],
              labels: this.labelsPrioridades
            },
            options: {
              legend: {
                display: false
              },
              responsive: true
            }
          };

          let canvasBarPrioridad: any = document.getElementById("barPrioridades");

          this.BarEmpresa = new chart(canvasBarPrioridad, configBarPrioridades);

        });
    }*/
    //#####################END PRIORIDADES##########################//
    //###################ASESORES###########################//
    else if (grafica == 'asesores') {
      this.graficaService.getGrafica(grafica)
        .subscribe((data) => {
          //alert(JSON.stringify(this.labelsCategorias));
          this.dataServiceAsesores = data;
          this.mostrarAsesor = true;
          this.dataServiceAsesores.forEach((value: any, key: any) => {
            this.labelsAsesores.push(value.nombre);
            this.dataAsesores.push(value.cantidad);
            let color = this.colorService.getRandomColor(key);
            this.backgroundColorAsesor.push(color);
            //this.hoverBackgroundColorCategoria.push(color);


            //alert(JSON.stringify(value));
          });

          let configBarAsesores = {
            type: 'bar',
            data: {
              datasets: [{
                label: 'Solicitudes',
                backgroundColor: this.backgroundColorAsesor,
                borderColor: this.backgroundColorAsesor,
                borderWidth: 1,
                data: this.dataAsesores
              }],
              labels: this.labelsAsesores
            },
            options: {
              legend: {
                display: false
              },
              responsive: true
            }
          };

          let canvasBarAsesor: any = document.getElementById("barAsesores");

          this.agenciasStacked = new chart(canvasBarAsesor, configBarAsesores);

        });
    }
    //#####################END ASESORES##########################//

  }

  cargar() {
    alert("Aqui inicio");
  }

  ngOnInit() {
    //this.cargar();
    
    //this.getGraficas('medios');
    //this.getGraficas('asesores');
    this.ruta.setRuta();
  }



}
